var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_vm._v(" верстка экранов транша "),_c('div',{staticClass:"node-edit__views"},[_c('EmiPlanCombined'),_c('MainScreen'),_c('StatusDisplay'),_c('AuthOtp'),_c('TransferFunds'),_c('ProductOrder'),_c('TarifsNode'),_c('EmiPlan'),_c('RedirectToFrame'),_c('FrameNode')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }